enum Platform {
    IOS = 'ios',
    ANDROID = 'android',
}

export function isAppBrowserAgent() {
    const userAgent = window.navigator.userAgent || '';
    return userAgent.includes('PerpayAppBrowser');
}

export function isIosAgent() {
    const userAgent = window.navigator.userAgent || '';
    return userAgent.includes('PerpayAppBrowserIos');
}

export function isAndroidAgent() {
    const userAgent = window.navigator.userAgent || '';
    return userAgent.includes('PerpayAppBrowserAndroid');
}

/** @knipignore could be useful for future mobile browser detection features */
export function getMobileBrowserPlatform(): Platform | null {
    if (!window.navigator.userAgent) {
        return null;
    }

    const userAgent = window.navigator.userAgent.toLowerCase();

    const isAndroid = /android/i.test(userAgent);
    if (isAndroid) {
        return Platform.ANDROID;
    }

    const isIOS = /iphone|ipad|ipod/i.test(userAgent);
    if (isIOS) {
        return Platform.IOS;
    }

    return null;
}
